import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT,
    headers: {
        Authorization: 'Bearer ' + process.env.VUE_APP_TOKEN,
    },
});

const salesChannelApi = axios.create({
    baseURL: process.env.VUE_APP_SALES_CHANNEL_URL,
    headers: {
        Authorization: 'Bearer ' + process.env.VUE_APP_TOKEN,
    },
});

export { api, salesChannelApi };
